import { REFRESH_TOKEN_URL } from "../config";
import Session from "./Session";
import Validations from "./Validations";

const refreshAt = 40000 // 40 seg - tiempo antes que caduque sesion

function getRefreshTimeOut() {
    const tokenExpTime = new Date(localStorage.expireDate).getTime();
    const nowTime = new Date().getTime();

    //si carga el sitio justo cdo esta x caducar
    if (tokenExpTime - nowTime < refreshAt) {
        return 1;
    }

    return tokenExpTime - nowTime - refreshAt;
}

function getNewToken() {
    const formData = new FormData();
    formData.append("grant_type", "refresh_token");
    formData.append("refresh_token", localStorage.getItem("refresh_token"));

    fetch(REFRESH_TOKEN_URL, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            Session.setToken(data.access_token, data.expires_in);
            Session.setRefreshToken(data.refresh_token);
            Session.setUser({
                userName: data.username,
                isAdmin: Validations.userIsAdmin(data.roles),
            });

            initTokenTimeout();
        })
        .catch((err) => {
            console.error(err);
        });
}

export function initTokenTimeout() {
    setTimeout(() => {
        getNewToken();
    }, getRefreshTimeOut());
}



// WEBPACK FOOTER //
// ./src/utils/TokenRefresh.js